const purchaseAr = {
    vendor: require('../../lang/ar/purchase/Vendor').default,
};

export default purchaseAr;